import { useQuery } from '@tanstack/react-query';
import useUser from '../global/useUser';
import { getBookingSite } from '../../services/bookingSite';

function useGetBookingSite() {
  const { user } = useUser();
  const businessId = user?.business?.id;

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ['bookingSite', businessId],
    queryFn: async () => {
      if (!businessId) return null;
      return getBookingSite(businessId);
    },
    enabled: !!businessId,
  });

  return { settings: data, isLoading, isError, refetch };
}

export default useGetBookingSite;
